import { useEffect, useState } from "react";
import androidAppService from "../services/androidApp.service";
import QRCode from "react-qr-code";
import { Button } from "../../../components/ui";
import localization from "../../../config/localization";

export default function AndroidApp() {

    const [qrValue, setQrValue] = useState("");
    const [androidAppUrl, setAndroidAppUrl] = useState("");


    useEffect(() => {
        androidAppService.getAndroidApp().then((response) => {
            setAndroidAppUrl(response.data?.url ?? "");
        });
    }, []);

    useEffect(() => {
        generateQRCode();
    }, []);

    useEffect(() => {
        if (
            androidAppUrl &&
            window.location.pathname.includes("android-app/scan")
        ) {
            downloadAndroidApp();
        }
    }, [androidAppUrl]);

    const generateQRCode = () => {
        const baseUrl = window.location.origin;
        const scanUrl = `${baseUrl}/android-app/scan`;
        setQrValue(scanUrl);
    };

    const downloadAndroidApp = async () => {
        window.location.assign(androidAppUrl);
        await androidAppService.insertAppAnalytics({
            deviceId: null,
            deviceInfo: null,
            eventType: "App_Download",
            platform: null,
        });
    };

    return (
        <div className="min-h-screen bg-black text-white">
      <section className="mx-auto grid max-w-7xl gap-6 px-4 py-6 sm:px-6 lg:py-8">
        <div className="overflow-hidden rounded-[24px] sm:rounded-[32px] border border-zinc-800 bg-zinc-900 shadow-2xl">
          <div className="relative">
                        <img
                            src="/images/logo.svg"
                            alt="Main banner"
              className="absolute inset-0 h-80 w-full object-contain object-right opacity-30"
                        />

                        <div className="relative z-10 flex h-full flex-col justify-between p-5 sm:p-8 md:p-10">
                            <div className="max-w-2xl">
                                <h1 className="text-3xl font-black leading-tight sm:text-4xl md:text-5xl lg:text-6xl">
                                    {localization.app_title}
                                </h1>
                                <p className="mt-4 max-w-xl text-sm text-zinc-300 sm:text-base md:text-lg">
                                    {localization.app_description}
                                </p>
                            </div>

                            <div className="pt-6">
                                <Button className="rounded-2xl bg-primary-gradient px-5 py-3 text-sm font-semibold transition hover:opacity-90 sm:px-6 sm:text-base"
                                    onClick={downloadAndroidApp}
                                >
                                    {localization.download_app}
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="mx-auto max-w-7xl px-4 py-8 sm:px-6 sm:py-10">
                <div className="grid gap-8 rounded-[28px] sm:rounded-[36px] border border-zinc-800 bg-gradient-to-br from-zinc-900 to-zinc-950 p-5 sm:p-8 lg:grid-cols-2">
                    <div>
                        <div className="mb-3 inline-flex rounded-full border border-pink-500/40 bg-pink-500/10 px-4 py-2 text-xs font-medium text-pink-400 sm:text-sm">
                            {localization.app_pagetitle}
                        </div>

                        <h2 className="text-3xl font-black sm:text-4xl">
                            {localization.app_install_steps}
                        </h2>

                        <div className="mt-8 space-y-5">
                            {[
                                localization.app_install_step1,
                                localization.app_install_step2,
                                localization.app_install_step3,
                            ].map((step, index) => (
                                <div key={step} className="flex items-start gap-4">
                                    <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl bg-primary-gradient font-bold text-sm sm:text-base">
                                        {index + 1}
                                    </div>
                                    <p className="pt-2 text-sm text-zinc-300 sm:text-lg">
                                        {step}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="flex items-center justify-center">
                        <div className="w-full max-w-sm rounded-[28px] sm:rounded-[32px] border border-zinc-800 bg-black p-5 sm:p-8 shadow-2xl">
                            <div className="mx-auto h-48 w-48 rounded-2xl bg-white p-4 sm:h-64 sm:w-64">
                                {qrValue && (
                                    <div >
                                        <QRCode value={qrValue} style={{ width: "100%", height: "100%" }} />
                                    </div>
                                )}
                            </div>
                            <p className="mt-6 text-center text-sm text-zinc-400 sm:text-base">
                                {localization.app_scan_to_download}
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="mx-auto max-w-7xl px-4 py-10 sm:px-6 sm:py-14">
                <div className="mb-10 text-center">
                    <h2 className="text-3xl font-black sm:text-4xl">
                        {localization.app_why_use_new_android_app}
                    </h2>
                    <p className="mt-3 text-sm text-zinc-400 sm:text-base">
                        {localization.app_why_use_new_android_app_description}
                    </p>
                </div>

                <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
                    {[
                        {
                            title: localization.app_exclusive_bonuses,
                            desc: localization.app_exclusive_bonuses_description,
                            icon: '🎁',
                        },
                        {
                            title: localization.app_instant_notifications,
                            desc: localization.app_instant_notifications_description,
                            icon: '🔔',
                        },
                        {
                            title: localization.app_secure_private,
                            desc: localization.app_secure_private_description,
                            icon: '🛡️',
                        },
                        {
                            title: localization.app_faster_experience,
                            desc: localization.app_faster_experience_description,
                            icon: '⚡',
                        },
                    ].map((feature) => (
                        <div
                            key={feature.title}
                            className="rounded-[24px] sm:rounded-[28px] border border-zinc-800 bg-zinc-900 p-6 sm:p-8 text-center shadow-lg"
                        >
                            <div className="mb-5 text-4xl sm:text-5xl">{feature.icon}</div>
                            <h3 className="text-xl font-bold sm:text-2xl">
                                {feature.title}
                            </h3>
                            <p className="mt-3 text-sm text-zinc-400 sm:text-base">
                                {feature.desc}
                            </p>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
}

